/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    declare var headerFooterModelSelf: HeaderFooterModel;

    export class HeaderFooterModel {

        constructor(
            private scope: angular.IScope,
            private growlService: angular.growl.IGrowlService) {
            headerFooterModelSelf = this;
        }
    }
}